import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Network, Users, ShieldCheck } from "lucide-react";

// Aplatit l'arbre hiérarchique en liste (poste, profondeur) — itératif
function flattenTree(roots) {
  const out = [];
  const stack = roots.map(r => [r, 0]).reverse();
  let guard = 0;
  while (stack.length > 0 && guard < 1000) {
    guard += 1;
    const [node, depth] = stack.pop();
    out.push([node, depth]);
    const children = node.children || [];
    for (let i = children.length - 1; i >= 0; i -= 1) {
      stack.push([children[i], depth + 1]);
    }
  }
  return out;
}

export default function OrganigrammePage() {
  const [tree, setTree] = useState([]);
  const [catalog, setCatalog] = useState([]);

  useEffect(() => {
    api.get("/rbac/organigramme").then(r => setTree(r.data)).catch(() => {});
    api.get("/rbac/permissions").then(r => setCatalog(r.data)).catch(() => {});
  }, []);

  const permLabel = (k) => catalog.find(p => p.key === k)?.label || k;
  const flat = flattenTree(tree);

  return (
    <div className="space-y-4" data-testid="organigramme-page">
      <div>
        <div className="chip mb-2"><Network className="h-3 w-3" /><span>ORGANIGRAMME</span></div>
        <h1 className="font-heading font-extrabold text-3xl text-[#1E3A8A]">Organigramme de l&apos;établissement</h1>
        <p className="text-slate-500 mt-1">Hiérarchie des postes, titulaires et habilitations. Modifiable depuis « Postes & habilitations ».</p>
      </div>

      {flat.length === 0 && (
        <div className="bg-white rounded-2xl border border-dashed border-slate-300 p-10 text-center text-slate-500">
          <ShieldCheck className="h-8 w-8 mx-auto mb-2 text-slate-300" />
          Aucun poste défini — créez vos postes dans « Postes & habilitations ».
        </div>
      )}

      <div className="space-y-3">
        {flat.map(([poste, depth]) => (
          <div key={poste.id} style={{ marginLeft: `${depth * 28}px` }}
               className={depth > 0 ? "border-l-2 border-slate-200 pl-4" : ""}>
            <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-4 inline-block min-w-72" data-testid={`org-node-${poste.id}`}>
              <div className="font-heading font-bold text-[#1E3A8A]">{poste.name}</div>
              {poste.responsibilities && <div className="text-xs text-slate-500 mt-1">{poste.responsibilities}</div>}
              <div className="flex items-center gap-1 text-xs text-slate-600 mt-2">
                <Users className="h-3 w-3" />
                {(poste.holders || []).length > 0
                  ? poste.holders.map(h => h.full_name || h.email).join(", ")
                  : <span className="text-slate-400">Poste vacant</span>}
              </div>
              <div className="flex flex-wrap gap-1 mt-2">
                {(poste.permissions || []).slice(0, 4).map(k => (
                  <span key={k} className="text-[10px] px-1.5 py-0.5 rounded-full bg-blue-50 text-[#1E3A8A] font-semibold">{permLabel(k)}</span>
                ))}
                {(poste.permissions || []).length > 4 && <span className="text-[10px] text-slate-400">+{poste.permissions.length - 4}</span>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
